import React, { Component } from 'react';
import {toast } from 'react-toastify';
import cookie from 'react-cookies';
import $ from 'jquery';
import {updateValueInJson} from '../../../../../functions';
import axios from 'axios';
import {API_URL} from '../../../../../constants';

let lastOrdenCreate = 0;
export default class ListasReproduccion extends Component {

    constructor(props) {

        super(props); 

        this.state = { 
            resource:{
                tempId:0,
                pmod_Id:this.props.pmod_Id,
                capr_Id:0,
                capr_Titulo:"",
                capr_Lista:"",
                sect_Id:null,
                capr_Orden:0,
                capr_Activo:true,
                capr_Eliminado:false
            },
            resourceEdit:{
                tempId:0,
                pmod_Id:this.props.pmod_Id,
                capr_Id:0,
                capr_Titulo:"",
                capr_Lista:"",
                sect_Id:null,
                capr_Orden:0,
                capr_Activo:true,
                capr_Eliminado:false
            },
            listas:this.props.listas,
            sectores:this.props.sectores,
            Validacion: {
                capr_Titulo: {
                    Error: false,                    
                },
                capr_Lista: {
                    Error: false,                    
                },
                capr_Orden: {
                    Error: false,                    
                }
            },
            ValidacionEdit: {
                capr_Titulo: {
                    Error: false,                    
                },
                capr_Lista: {
                    Error: false,                    
                },
                capr_Orden: {
                    Error: false,                    
                }
            },
            hasError:false,
            added:false,
            confirmStore:false,
            security: cookie.load('user'),
            roles: []
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeEdit = this.handleInputChangeEdit.bind(this);
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let validaciones = this.state.Validacion;

        validaciones[target.name] = {
            Error: false,                    
        }

        this.setState({
            resource: copyResource,
            Validacion: validaciones
        });  
    }

    handleInputChangeEdit(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resourceEdit;
        copyResource[target.name] = value;

        let validaciones = this.state.ValidacionEdit;

        validaciones[target.name] = {
            Error: false,                    
        }

        this.setState({
            resourceEdit: copyResource,
            ValidacionEdit: validaciones
        });  
    }

    showAgregar = (e) => {

        e.preventDefault();

        $(".containerFormCreationLista").fadeIn();  
        $("#btnGuardar").fadeIn();
        $("#btnAgregar").fadeOut();
    }

    hideAgregar = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        $(".containerFormCreationLista").fadeOut();  
        $("#btnGuardar").fadeOut();
        $("#btnAgregar").fadeIn();
    }

    update = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resourceEdit.capr_Titulo == '') {              
            newState.ValidacionEdit.capr_Titulo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.capr_Lista == '') {              
            newState.ValidacionEdit.capr_Lista = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.capr_Orden == '') {  
            newState.ValidacionEdit.capr_Orden = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        setTimeout(() => { 
            this.retornarAPadre();
        }, 100); 

        this.cancelarEdicion();

    }

    storeLista = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.capr_Titulo == '') {              
            newState.Validacion.capr_Titulo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.capr_Lista == '') {              
            newState.Validacion.capr_Lista = {Error: true};
            newState.hasError = true;
        }
        lastOrdenCreate = lastOrdenCreate + 1;
        newState.resource.capr_Orden = lastOrdenCreate;
        newState.resource.tempId = lastOrdenCreate;

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        let titulo = document.getElementById("capr_Titulo").value;
        let lista = document.getElementById("capr_Lista").value;
        let sect_Id = document.getElementById("lista_sect_Id").value;
        let resource = {
            capr_Titulo:titulo,
            capr_Lista:lista,
            capr_Orden:lastOrdenCreate,
            sect_Id:sect_Id,
            tempId:lastOrdenCreate,
            capr_Activo:1,
            capr_Id:0
        }

        var listas = newState.listas;
        listas.push(resource);
        newState.listas = listas;
        newState.resource.capr_Titulo = "";
        newState.resource.capr_Lista = "";
        newState.resource.capr_Orden = 0;
        newState.resource.sect_Id = 0;
        

        this.setState(newState);
        this.hideAgregar();

        setTimeout(() => { 
            this.retornarAPadre();
        }, 100); 

    }

    cancelarEdicion = () => {
        
        this.setState({
            resourceEdit:{
                capr_Id:0,
                capr_Titulo:"",
                capr_Lista:"",
                sect_Id:null,
                capr_Orden:0,
                capr_Activo:true
            }
        });
    }

    editRegistro = (entity, e) => {

        e.preventDefault();
        let newEntity = entity;
        this.setState({resourceEdit: newEntity});
    }

    eliminarRegistro = async(entity) => {
        entity.capr_Eliminado = true;

        setTimeout(() => { 
            this.retornarAPadre();
        }, 100); 
        
        return; 
    }

    actualizarEstado = (entity, e) => {

        e.preventDefault();
        entity.capr_Activo = !entity.capr_Activo;

        let newState = this.state;
        this.setState(newState);

    }

    retornarAPadre = () => {

        let listas = this.state.listas;
        this.props.callback(listas);        
    }

    componentWillReceiveProps(nextProps){
        lastOrdenCreate = nextProps.listas.length;
        this.setState({listas: nextProps.listas})        
    } 

    render() {
        return (
            <div className="divModulo_Seo">
                <h2><strong>Listas de Reproducción</strong></h2>
                <div className="divWrapperModulo_Seo">

                        {
                            this.state.listas.length > 0 ?
                            <div className="divModuloPopup_Panel">
                                {
                                    this.state.listas.map((lista) => (
                                        <React.Fragment>
                                            {
                                                (! lista.capr_Eliminado) ?  
                                                    <React.Fragment>
                                                    <div className="txtFile x-1">
                                                        <input type="text" readOnly placeholder="Titulo" value={lista.capr_Titulo}/>
                                                        <div className="divBtnAccionesPopup_Panel">
                                                            {
                                                                lista.capr_Id > 0 ?
                                                                <a href="#" className={lista.capr_Activo ? "btnPageModuloVer noneEvent" : "btnPageModuloInactivo noneEvent"} onClick={(e) => this.actualizarEstado(lista, e)}/>                       
                                                                : null
                                                            }                                                
                                                            <a href="#" className="btnPageModuloEditar noneEvent" onClick={(e) => this.editRegistro(lista, e)}/>
															
															
                                                            <a href className="btnPageModuloEliminar aEliminarMenu2"/>
															<div className="c_divAlertaCapa">
																<div className="divAlertaCapa">
																	<div className="divAlerta">
																		<h2>&iquest;Seguro de eliminar?</h2>
																		<div className="divAlertaBtn">
																			<a href="#" className="btnAlertaAceptar" onClick={() => this.eliminarRegistro(lista)}>ACEPTAR</a>
																			<a href="#" className="btnAlertaCancelar">CANCELAR</a>
																		</div>
																	</div>
																</div>
															</div>
															
															
															
                                                        </div>
                                                    </div>
                                                    {
                                                        (this.state.resourceEdit.capr_Id == lista.capr_Id && lista.capr_Id > 0) 
                                                        || (lista.tempId == this.state.resourceEdit.tempId && lista.tempId > 0)?
                                                        <div className="containerFormEdit divModuloPopup_Panel">
                                                            <div className="txtFile x-1">
                                                                <input type="text" 
                                                                placeholder="Título" 
                                                                name='capr_Titulo' 
                                                                value={this.state.resourceEdit.capr_Titulo} 
                                                                maxLength={200} 
                                                                className={this.state.ValidacionEdit.capr_Titulo.Error ? "error" : ""}  
                                                                onChange={this.handleInputChangeEdit}/>
                                                            </div>
                                                            <div className="txtFile x-1">
                                                                <input type="text" 
                                                                placeholder="Lista de Reproducción" 
                                                                name='capr_Lista'
                                                                className={this.state.ValidacionEdit.capr_Lista.Error ? "error" : ""}
                                                                value={this.state.resourceEdit.capr_Lista} 
                                                                onChange={this.handleInputChangeEdit}/>
                                                            </div>

                                                            <div className="txtFile x-1">
                                                                <select name='sect_Id' id='sect_Id' 
                                                                onChange={this.handleInputChangeEdit} >
                                                                    <option value="0">Seleccionar Sector</option>
                                                                    {
                                                                        this.state.sectores.length > 0 ?
                                                                        this.state.sectores.map((sector) => (
                                                                            <option value={sector.id} selected={(this.state.resourceEdit.sect_Id == sector.id) ? true : false}>{sector.nombre.toUpperCase()}</option>
                                                                        ))
                                                                        : null
                                                                    }
                                                                </select>                        
                                                            </div>

                                                            <div className="txtFile x-2">
                                                                <input type="text" placeholder="Orden" name='capr_Orden' value={this.state.resourceEdit.capr_Orden} maxLength={2} className={this.state.ValidacionEdit.capr_Orden.Error ? "error" : ""} onChange={this.handleInputChangeEdit}/>
                                                            </div>
                                                            <div className="clear"></div>
                                                            <div className="txtFile x-2">
                                                                <a href="" className="btnAgregarPagina" id="btnActualizar" onClick={(e) => this.update(e)}>ACTUALIZAR</a>
                                                                <a href="" className="btnAgregarPagina noneEvent" id="btnCancelarActualizar" onClick={() => this.cancelarEdicion()}>CANCELAR</a>
                                                            </div>
                                                            
                                                        </div>
                                                        : null
                                                    }
                                                    </React.Fragment>
                                                : null
                                            }
                                        </React.Fragment>
                                    ))
                                }
                            </div> : null
                        }
                    
                    <div className="containerFormCreationLista divModuloPopup_Panel" style={{display:"none"}}>
                        <div className="txtFile x-1">
                            <input type="text" 
                            placeholder="Título" 
                            name='capr_Titulo' 
                            id='capr_Titulo'
                            value={this.state.resource.capr_Titulo} 
                            maxLength={200} className={this.state.Validacion.capr_Titulo.Error ? "error" : ""}  
                            onChange={this.handleInputChange}/>
                        </div>
                        <div className="txtFile x-1">
                            <input type="text" 
                            placeholder="Lista de Reproducción" 
                            name='capr_Lista'
                            id='capr_Lista'
                            className={this.state.Validacion.capr_Lista.Error ? "error" : ""}
                            value={this.state.resource.capr_Lista} 
                            onChange={this.handleInputChange}/>
                        </div>

                        <div className="txtFile x-1">
                            <select 
                            name='sect_Id' 
                            id='lista_sect_Id' 
                            onChange={this.handleInputChange} >
                                <option value="0">Seleccionar Sector</option>
                                {
                                    this.state.sectores.length > 0 ?
                                    this.state.sectores.map((sector) => (
                                        <option value={sector.id} selected={(this.state.resource.sect_Id == sector.id) ? true : false}>{sector.nombre.toUpperCase()}</option>
                                    ))
                                    : null
                                }
                            </select>                        
                        </div>
                    </div>

                    <div className="divAgrupadorBotones">
                        <a href="" className="btnAgregarPagina" id="btnAgregar" onClick={(e) => this.showAgregar(e)}>AGREGAR NUEVA LISTA</a>
                        <a href="" style={{display:"none"}} className="btnAgregarPagina" id="btnGuardar" onClick={(e) => this.storeLista(e)}>AGREGAR</a>
                        <br/>
                        <br/>
                        <br/>
                    </div>
                    
                </div>
            </div>
        )
    }
}
